import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function ExternalIcon(props) {
  return (
    <SvgIcon enableBackground="new 0 0 24 24" viewBox="0 0 24 24" {...props}>
      <path
        clipRule="evenodd"
        d="m9.6 1.5 2.4 2.6h-7.8v15.7h15.7v-8.2l2.6 2.7v8.1h-21v-21h8.1zm13 0v9.1l-3.4-3.5-6.2 6.2-.4.4-2.2-2.2.4-.4 6.2-6.2-3.3-3.3h8.9z"
      />
    </SvgIcon>
  );
}

export default ExternalIcon;
